/* global tinymce */
import { getCurrentDateTemplate } from "../../shortcodes/templates";

let activeTab = "Predefined Date Formats";
const dynamicDateConfig = {
  title: "Dynamic Date",
  body: {
    type: "tabpanel",
    tabs: [
      {
        name: "Predefined Date Formats",
        title: "Predefined",
        items: [
          {
            type: "listbox",
            name: "dateType",
            label: "Select Predefined Date Format",
            disabled: false,
            items: [
              {
                text: "Monday, January 31, 2000",
                value: "EEEE, MMMM d, yyyy",
              },
              {
                text: "Monday, 31 January, 2000",
                value: "EEEE, d MMMM, yyyy",
              },
              {
                text: "31 January, 2000",
                value: "d MMMM, yyyy",
              },
              {
                text: "31 Jan, 2000",
                value: "d MMM, yyyy",
              },
              {
                text: "January 31, 2000",
                value: "MMMM d, yyyy",
              },
              {
                text: "Jan 31, 2000",
                value: "MMM d, yyyy",
              },
              {
                text: "January 2000",
                value: "MMMM yyyy",
              },
              {
                text: "Jan 2000",
                value: "MMM yyyy",
              },
              {
                text: "January 31",
                value: "MMMM d",
              },
              {
                text: "Jan 31",
                value: "MMM d",
              },
              {
                text: "31 01 2000",
                value: "d MM yyyy",
              },
              {
                text: "2000 01 31",
                value: "yyyy MM d",
              },
              {
                text: "01 31",
                value: "MM d",
              },
              {
                text: "31 01",
                value: "d MM",
              },
            ],
          },
          {
            type: "input",
            name: "dateOffset",
            label: "Date Offset in days",
            placeholder: "0",
          },
        ],
      },
      {
        name: "Custom Date Formats",
        title: "Custom",
        items: [
          {
            type: "htmlpanel", // component type
            html: '<span>To use a custom date format, please <a target="_blank" href="https://help.siterunner.com/help/design-elements-what-is-a-dynamic-date-button?version=latest">see documentation</a>.</span>',
          },
          {
            type: "input",
            name: "customDateFormat",
            inputMode: "text",
            placeholder: "dddd, MMMM d, yyyy",
            disabled: false,
          },
          {
            type: "input",
            name: "dateOffset",
            label: "Date Offset in days",
            placeholder: "0",
          },
        ],
      },
    ],
  },
  buttons: [
    {
      type: "cancel",
      name: "closeButton",
      text: "Cancel",
    },
    {
      type: "submit",
      name: "submitButton",
      text: "Insert",
      primary: true,
    },
  ],
  onTabChange: (api, details) => {
    activeTab = details.newTabName;
  },
  onSubmit: function (api) {
    const { dateOffset, dateType, customDateFormat } = api.getData();
    if (activeTab === "Custom Date Formats") {
      tinymce.activeEditor.execCommand("mceInsertContent", false, getCurrentDateTemplate(customDateFormat, dateOffset));
    } else {
      tinymce.activeEditor.execCommand("mceInsertContent", false, getCurrentDateTemplate(dateType, dateOffset));
    }

    // resets active tab to initial position
    activeTab = "Predefined Date Formats";
    api.close();
  },
};

export { dynamicDateConfig };
